import type { DiagnosticCategory } from '@patsnap/synapse_common_utils'

export const DIAGNOSTIC_SCHEMA_VERSION = 1 as const
export const DIAGNOSTIC_NAMESPACE = 'synapse_diagnostics'
export const DIAGNOSTIC_SOURCE_APP = 'pharmsnap-web'
export const DIAGNOSTIC_WINDOW_MS = 3 * 60 * 1000
export const DIAGNOSTIC_STORAGE_MAX_BYTES = 1024 * 1024
export const DIAGNOSTIC_STORAGE_KEY = `${DIAGNOSTIC_NAMESPACE}:v${DIAGNOSTIC_SCHEMA_VERSION}`
export const DIAGNOSTIC_RECORDING_STORAGE_KEY = `${DIAGNOSTIC_NAMESPACE}:recording:v${DIAGNOSTIC_SCHEMA_VERSION}`
export const DIAGNOSTIC_STORAGE_DEBOUNCE_MS = 4000

export const DIAGNOSTIC_CATEGORY_LIMITS: Record<DiagnosticCategory, number> = {
  error: 100,
  console: 100,
  request: 200,
  route: 50,
  interaction: 100,
  resource: 100,
}
